import { useContext, useMemo } from "react";
import { routes } from "../routes";
import { verifyRight } from "./users";
import { UserContext } from "../App";

export default function useRoutes() {
  const { user, userInfos, loading } = useContext(UserContext);
  const cRoutes = useMemo(() => routes.map((r) => ({ ...r })), []);

  const result = useMemo(() => {
    if (loading || !user || !userInfos)
      return { menuRoutes: [], modalRoutes: [] };

    const allowedRoutesToDisplay = cRoutes.filter((route) => {
      if (!route.display) return false;
      if (route.isPublic) return true;
      if (route.adminOnly && userInfos.createdBy) return false;

      let action = route.addLabel ? "create" : "read";

      if (route.objects) {
        let access = false;
        for (let object of route.objects) {
          if (verifyRight(userInfos, object.object, action)) {
            if (!access) route.path = object.path;
            access = true;
          }
        }

        return access;
      } else if (route.object) {
        return verifyRight(userInfos, route.object, action);
      }

      return true;
    });

    const menuFiltered = allowedRoutesToDisplay.filter(
      (route) => !route.addLabel && route.icon
    );
    const modalFiltered = allowedRoutesToDisplay.filter(
      (route) => route.addLabel
    );

    return { menuRoutes: menuFiltered, modalRoutes: modalFiltered };
  }, [loading, user, userInfos, cRoutes]);

  return result;
}
